'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.action = action;
exports.decorateAction = decorateAction;

var _addons = require('@storybook/addons');

var _addons2 = _interopRequireDefault(_addons);

var _v = require('uuid/v1');

var _v2 = _interopRequireDefault(_v);

var _ = require('./');

var _util = require('./lib/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function action(name) {
  // eslint-disable-next-line no-shadow
  var handler = function action() {
    for (var _len = arguments.length, _args = Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    var args = _args.map(_util.prepareArguments);
    var channel = _addons2.default.getChannel();
    var id = (0, _v2.default)();
    channel.emit(_.EVENT_ID, {
      id: id,
      data: { name: name, args: args }
    });
  };

  if (_util.canConfigureName && name && typeof name === 'string') {
    Object.defineProperty(handler, 'name', { value: name });
  }
  return handler;
}

function decorateAction(decorators) {
  return function (name) {
    var callAction = action(name);
    return function () {
      for (var _len2 = arguments.length, _args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        _args[_key2] = arguments[_key2];
      }

      var decorated = decorators.reduce(function (args, fn) {
        return fn(args);
      }, _args);
      callAction.apply(undefined, (0, _toConsumableArray3.default)(decorated));
    };
  };
}